import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChallansHistoryService {

  public key = localStorage.getItem('currentToken');

  constructor(private _http: HttpClient) { }
  getData(key:any = this.key): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}customer-dispatch-history`, { key })
      .pipe(
        map(data => {
          return data;
        })
      );
  }
}
